import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { singularize, toPascalCase } from '@cli-utils/text.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
import { renderMultiRelationshipField } from './render-multi-relationship-field.js'
import { renderSingleRelationshipField } from './render-single-relationship-field.js'

export function renderRelationshipField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const relName = field.relationship!
  const relSingular = singularize(relName)
  const relPascal = toPascalCase(relSingular)
  const isUserRelationship = isUserRelationshipTarget(relName)
  const displayField = isUserRelationship
    ? `(('name' in item && item.name) || ('email' in item && item.email) || \`User \${item.id ?? 'Unknown'}\`) as string`
    : `(('name' in item && item.name) || ('title' in item && item.title) || ('label' in item && item.label) || \`${relPascal} \${item.id ?? 'Unknown'}\`) as string`
  const secondaryDisplayField = isUserRelationship
    ? `('email' in item && item.email && item.email !== displayName ? String(item.email) : null)`
    : 'null'
  const dataArray = `${relName}Data?.${relName}`

  if (field.multiple) {
    return renderMultiRelationshipField(
      field,
      indent,
      label,
      hintJSX,
      displayField,
      secondaryDisplayField,
      dataArray,
      relSingular,
      context
    )
  }

  return renderSingleRelationshipField(
    field,
    indent,
    label,
    hintJSX,
    displayField,
    secondaryDisplayField,
    dataArray,
    relSingular,
    context
  )
}
